import { Component } from '@angular/core';
import { Icons } from 'src/app/models/icons.model';
import { NgOptimizedImage } from '@angular/common';
import { AlertModel } from 'src/app/models/alert.model';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-action-alert-help',
  standalone: false,
  templateUrl: './action-alert-help.component.html',
  styleUrls: ['./action-alert-help.component.scss'],
  providers: [NgOptimizedImage],
})
export class ActionAlertHelpComponent {
  selectedAlert?: AlertModel = null;
  icons = new Icons();

  constructor(public adminService: AdminService) { }

  changeAlert() {
    console.log('Selected Alert:', this.selectedAlert);
  }

  copyUrlToClipboard() {
    var url = `https://valcoatweb/acs-api/acs/events/trigger?alertId=${this.selectedAlert?.Id}`;
    navigator.clipboard.writeText(url).then(() => {
      console.log('URL copied to clipboard:', url);
    }).catch(err => {
      console.error('Failed to copy URL: ', err);
    });
  }
}
